import { Component, DestroyRef, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IModule, IModuleImpact } from '../../setups/models/setup.interface';
import { ModuleService } from '../../setups/services/module.service';

// Módulos cuja desativação derruba fluxos inteiros do totem: exigem digitar o nome para confirmar.
const CRITICAL_MODULE_ROUTES = ['Module_Auth'];

@Component({
  selector: 'app-modal-desativar-modulo',
  templateUrl: './modal-desativar-modulo.component.html'
})
export class ModalDesativarModuloComponent implements OnInit {
  readonly module: IModule;
  readonly critical: boolean;
  readonly confirmName = new UntypedFormControl('');

  impact?: IModuleImpact;
  impactError = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: { module: IModule },
    private readonly moduleService: ModuleService,
    private readonly destroyRef: DestroyRef
  ) {
    this.module = data.module;
    this.critical = CRITICAL_MODULE_ROUTES.includes(this.module.route);
  }

  ngOnInit(): void {
    // Fechar o modal antes da resposta cancela a requisição.
    this.moduleService
      .getImpact(this.module.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          this.impactError = !response.isSucceed;
          this.impact = response.data;
        },
        error: () => (this.impactError = true)
      });
  }

  get canConfirm(): boolean {
    return !this.critical || String(this.confirmName.value || '').trim() === this.module.name;
  }
}
